export default {
    icon: {
        height: 'inherit',
    },
};
